'use client';

import type { MarketingPartnerSelector } from '@/lib/product/types';
import Image from 'next/image';
import styles from './MarketingSelectorButton.module.scss';

export interface MarketingSelectorButtonProps {
  /** Marketing partner selector data */
  selectorData: MarketingPartnerSelector;
  /** Click handler - typically opens the marketing selector modal */
  onClick: () => void;
}

export function MarketingSelectorButton({ selectorData, onClick }: MarketingSelectorButtonProps) {
  const { title, currentItem } = selectorData;

  return (
    <button
      type="button"
      className={styles.marketingSelectorButton}
      onClick={onClick}
      aria-label={title}
    >
      {currentItem?.imageUrl && (
        <div className={styles.imageContainer}>
          <Image
            src={currentItem.imageUrl}
            alt={currentItem.name || ''}
            width={36}
            height={36}
            className={styles.teamImage}
          />
        </div>
      )}
      <span className={styles.label}>{title}</span>
      <svg
        className={styles.chevron}
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.5 1L6.5 6L1.5 11"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

MarketingSelectorButton.displayName = 'MarketingSelectorButton';
